import React, { useRef, useState,useEffect  } from 'react';
import { 
    Autocomplete, 
    DrawingManager,
    Marker, 
    GoogleMap,
    KmlLayer, 
    Polygon,
    Rectangle,
    useJsApiLoader,
    InfoWindow, 
} from '@react-google-maps/api';
import currentLocationmarker from "../assets/images/marker.png";
import cityMarkerUser from "../assets/images/CityMarker.png";
import CoordinatesMarker from "../assets/images/coordinatesIcon-marker.png";
import Default_logo from "../assets/images/default_logo.png";
import MapSidebar from './MapSidebar';
//import { useUser } from '../context/UserContext';
//import { useNavigate } from "react-router-dom";
import { Modal, Button } from 'react-bootstrap'; 
import { area } from '@turf/turf';
import { polygon } from '@turf/helpers';

const baseUrl = process.env.REACT_APP_API_URL;
const libraries = ['places', 'drawing'];
const MAX_AREA_SQ_MILES = 100; // Area limit
const SQ_KM_TO_SQ_MILES = 0.386102; // Conversion from square kilometers to square miles

function Map() {
    const mapRef = useRef();
    const polygonRefs = useRef([]);
    const activePolygonIndex = useRef();
    const autocompleteRef = useRef();
    const drawingManagerRef = useRef();
    const kmlLayerRef = useRef(null);
    //const { userType } = useUser();
    //const navigate = useNavigate();

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
        libraries
    });
    const [polygons, setPolygons] = useState([
        // [
        //     { lat: 28.630818281028954, lng: 79.80954378826904 },
        //     { lat: 28.62362346815063, lng: 79.80272024853515 },
        //     { lat: 28.623585797675588, lng: 79.81490820629882 },
        //     { lat: 28.630818281028954, lng: 79.80954378826904 }
        // ],
        // [
        //     { lat: 28.63130796240949, lng: 79.8170110581665 },
        //     { lat: 28.623623468150655, lng: 79.81705397351074 },
        //     { lat: 28.623623468150655, lng: 79.82619494183349 },
        //     { lat: 28.6313832978037, lng: 79.82619494183349 },
        //     { lat: 28.63130796240949, lng: 79.8170110581665 }
        // ]
    ]);
        const [loading, setLoading] = useState(false);

    const defaultCenter = {
        lat: 0,
        lng: 0,
    };
    const auth = localStorage.getItem("auth");
    const authJsonObject = JSON.parse(auth);
    const [center, setCenter] = useState(defaultCenter);
    const [CurrentLocationMarkerPosition,setCurrentLocationMarkerPosition]= useState(null);
    const [markerPosition, setMarkerPosition] = useState(null);
    const [isCaptureCursor, setIsCaptureCursor] = useState(false);
    const [hoverCoordinates, setHoverCoordinates] = useState(null);
    const [isClickCaptured, setIsClickCaptured] = useState(false);
    const infoWindowRef = useRef(null);
    const [isPopupActive, setIsPopupActive] = useState(false);
    const [zoomLevel, setZoomLevel] = useState(2); 
    const [kmlUrl, setKmlUrl] = useState(null);
    const [shapeData, setShapeData] = useState(null); 
    const [isDisabled, setIsDisabled] = useState(false);
    const [markers, setMarkers] = useState([]);
    const [loadingMessage, setLoadingMessage] = useState(null);
    const [popupMessage, setPopupMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    //const handlePopupClose = () => setShowPopup(false);
    const [error, setError] = useState(null);  
    const [showErrorModal, setShowErrorModal] = useState(false);

    const containerStyle = {
      width: "calc(100vw - 60px)", // Adjusted width for map container
      height: "calc(100vh - 0px)", // Full height of viewport minus navbar height (60px)
      marginLeft: "0", // Offset by sidebar width
    };
      const mapContainerStyle = {
        position: "absolute",
        top: "0", 
        left: "0",
        right: "0",
        bottom: "0",
        margin: "0",
        padding: "0",
      };

    const autocompleteStyle = {
        boxSizing: 'border-box',
        border: '1px solid transparent',
        width: '200px',
        height: '38px',
        padding: '0 12px',
        borderRadius: '3px',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
        fontSize: '14px',
        outline: 'none',
        textOverflow: 'ellipses',
        position: 'absolute',
        right: '5%',
        top: '8px',
    };

    const sidebarStyle = {
    width: "0", // Fixed width for the sidebar
    height: "calc(100px - 60px)",
    position: "fixed",
    top: "0",
    left: "0",
    zIndex: 1,
    backgroundColor: "#f8f9fa",
    overflowY: "auto",
  };
    const polygonOptions = {
      strokeColor: "#0000FF", // Blue color for stroke
      strokeOpacity: 1,       // 100% opacity for stroke
      strokeWeight: 2,        // Stroke width
      fillColor: "#0000FF",   // Blue color for fill
      fillOpacity: 0.3,         // 100% transparency for fill
      draggable: false,
      editable: false,
    };

    const rectangleOptions = {
      strokeColor: "#0000FF", // Blue color for stroke
      strokeOpacity: 1,       // 100% opacity for stroke
      strokeWeight: 2,        // Stroke width
      fillColor: "#0000FF",   // Blue color for fill
      fillOpacity: 0.3,         // 100% transparency for fill
      draggable: false,
      editable: false,
    };
    const buttonStyle = {
      position: "absolute",
      bottom: "20px",
      left: "50%",
      transform: "translateX(-50%)",
      zIndex: 1, // Ensure button is on top of the map
    };

    const drawingManagerOptions = {
      polygonOptions: polygonOptions,
      rectangleOptions: rectangleOptions,
      drawingControl: true,
      drawingControlOptions: {
        position: window.google?.maps?.ControlPosition?.TOP_CENTER,
        drawingModes: [
          window.google?.maps?.drawing?.OverlayType?.POLYGON,
          window.google?.maps?.drawing?.OverlayType?.RECTANGLE,
        ],
      },
    };
    const onLoadMap = (map) => {
        mapRef.current = map;
        if (center) {
            map.setCenter(center);
            map.setZoom(zoomLevel);
          }
    };
    useEffect(() => {
        if (mapRef.current) {
          mapRef.current.setCenter(center);
          mapRef.current.setZoom(zoomLevel);
        }
      }, [center]);

    const onLoadPolygon = (polygon, index) => {
        polygonRefs.current[index] = polygon;
    };

    const onClickPolygon = (index) => {
        activePolygonIndex.current = index;
    };

    const onLoadAutocomplete = (autocomplete) => {
        autocompleteRef.current = autocomplete;
    };

    const onPlaceChanged = () => {
      const place = autocompleteRef.current.getPlace();
      
      if (!place || !place.geometry) {
          console.error("Place or geometry is not defined.");
          return;
      }
  
      const { geometry } = place;
      const bounds = new window.google.maps.LatLngBounds();
  
      // Check for viewport or fallback to location
      if (geometry.viewport) {
          bounds.union(geometry.viewport);
      } else if (geometry.location) {
          bounds.extend(geometry.location);
      }
  
      // Fit the map to the new bounds
      mapRef.current.fitBounds(bounds);
  };
  
    // const onPlaceChanged = () => {
    //     const { geometry } = autocompleteRef.current.getPlace();
    //     const bounds = new window.google.maps.LatLngBounds();
    //     if (geometry.viewport) {
    //         bounds.union(geometry.viewport);
    //     } else {
    //         bounds.extend(geometry.location);
    //     }
    //     mapRef.current.fitBounds(bounds);
    // };

    const onLoadDrawingManager = (drawingManager) => {
        drawingManagerRef.current = drawingManager;
    };
// Helper function to calculate the area of a polygon in square miles
const calculatePolygonArea = (path) => {
  const google = window.google;
  const areaInSquareMeters = google.maps.geometry.spherical.computeArea(path);
  return (areaInSquareMeters / 1e6) * SQ_KM_TO_SQ_MILES;
};

 const onOverlayComplete = ($overlayEvent) => {
    setKmlUrl(null); 
    if (kmlLayerRef.current) {
      kmlLayerRef.current.setMap(null);
      kmlLayerRef.current = null;
    }

    const filtered = polygons.filter(
      (polygon, index) => index !== activePolygonIndex.current
    );
    setPolygons(filtered);

    let newShape;
    let area = 0;

    if ($overlayEvent.type === window.google.maps.drawing.OverlayType.POLYGON) {
      const path = $overlayEvent.overlay.getPath().getArray();
      newShape = {
        type: "polygon",
        paths: path.map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() })),
      };

      const startPoint = newShape.paths[0];
      newShape.paths.push(startPoint);
      area = calculatePolygonArea(path);
    } else if ($overlayEvent.type === window.google.maps.drawing.OverlayType.RECTANGLE) {
      const bounds = $overlayEvent.overlay.getBounds();
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();

      newShape = {
        type: "rectangle",
        bounds: [
          { lat: sw.lat(), lng: sw.lng() },
          { lat: ne.lat(), lng: sw.lng() },
          { lat: ne.lat(), lng: ne.lng() },
          { lat: sw.lat(), lng: ne.lng() },
        ],
      };

      const path = [
        new window.google.maps.LatLng(sw.lat(), sw.lng()),
        new window.google.maps.LatLng(ne.lat(), sw.lng()),
        new window.google.maps.LatLng(ne.lat(), ne.lng()),
        new window.google.maps.LatLng(sw.lat(), ne.lng())
      ];

      area = calculatePolygonArea(path);
    }

    if (area > MAX_AREA_SQ_MILES) {
      $overlayEvent.overlay.setMap(null); // Remove the shape from the map
      setError(`The area exceeds the maximum allowed size of ${MAX_AREA_SQ_MILES} square miles.`);
      setShowErrorModal(true); // Show the error modal
      return;
    }

    $overlayEvent.overlay?.setMap(null);
    setPolygons([newShape]);

    const newPolygonDataItems =
      newShape.type === "rectangle"
        ? newShape.bounds.map((cord) => [cord.lng, cord.lat])
        : newShape.paths.map((cord) => [cord.lng, cord.lat]);

    if (!newPolygonDataItems) {
      console.error("Invalid polygon data", newShape);
      return;
    }

    const postData = {
      type: "Polygon",
      coordinates: [newPolygonDataItems],
      newPolygon: newShape,
    };

    setShapeData(postData);
    // Programmatically stop the drawing mode after shape completion
    drawingManagerRef.current.setDrawingMode(null);
    // Ready to use Kml generation API
   // generateKml(postData);
     // Clear shape data when user data is processed
  };

  // Function to handle modal close
  const handleCloseModal = () => {
    setShowErrorModal(false);
    setLoading(false);
  };

  const generateKml = async () => {
    setLoadingMessage("Searching for drone pilots and companies in and around your area of interest.");
    setLoading(true); // Show loader
    try {
        // Determine the correct payload
        let postData;
        if (kmlUrl) {
            postData = { kml_url: kmlUrl }; // Correct payload for KML URL
        } else if (shapeData) {
            postData = shapeData; // Use shape data if KML URL is not available
        } else {
            console.error("No KML URL or shape data available.");
            return;
        }

        const response = await fetch(`${baseUrl}/generate_customer_kml`, {
            method: "POST",
            body: JSON.stringify(postData),
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const json = await response.json();

        // Check if the response contains users and if they are valid
        if (json.intersection_data && json.intersection_data.users && json.intersection_data.users.length > 0) {
            await handleMultipleUsers(json.intersection_data.users);
        } else {
            // Set the popup message for no users found
            setPopupMessage("No drone operators or companies have been found in your area of interest. Would you like us to search for one?");
            setShowPopup(true);
        }

        // Store the response URL in localStorage
        if (json.response) {
            localStorage.setItem("kmlResponseUrl", json.response);
        }

    } catch (error) {
        console.error("Error posting data:", error);
    } finally {
        setLoading(false);
        setLoadingMessage(null);
    }
};


  // Function to handle multiple users and geocode each city
const handleMultipleUsers = async (users) => {
  const updatedMarkers = [];

  for (const user of users) {
      const { _id, city, country, ZIPCode, company_logo, email, drones_do_you_have, services, state, geometryfile, GeoWGS84_partner_no } = user;

      if (city && country) {
          const markerData = await geocodeCity(city, country);
          if (markerData) {
              // Include all user details in marker data
              updatedMarkers.push({
                  ...markerData,
                  ZIPCode,
                  company_logo,
                  email,
                  services,
                  drones_do_you_have,
                  state,
                  geometryfile,
                  GeoWGS84_partner_no,
                  _id
              });
          }
      } else {
          console.warn("User information is incomplete.");
      }
  }

  setMarkers(updatedMarkers);

  // Adjust map bounds based on all markers
  if (updatedMarkers.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();

      // Extend the bounds to include all marker positions
      updatedMarkers.forEach(marker => {
          bounds.extend(marker.position);
      });

      // Fit the map to the bounds (this will adjust zoom and center)
      if (mapRef.current) {
          mapRef.current.fitBounds(bounds);
      }
  }
};


const geocodeCity = async (city, country) => {
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
  const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${city},${country}&key=${apiKey}`;

  try {
      const response = await fetch(geocodeUrl);
      const data = await response.json();

      if (data.results.length > 0) {
          const location = data.results[0].geometry.location;
          const buffer = Math.random() * (0.0009 - 0.0005) + 0.0005;

          return {
              position: { lat: location.lat + buffer, lng: location.lng + buffer },
              city,
              country,
          };
      } else {
          setPopupMessage("No user found");
          setShowPopup(true);
          return null;
      }
  } catch (error) {
      console.error("Error geocoding the city:", error);
      return null;
  }
};

const handleDetailClick = (user) => {
  const userJson = JSON.stringify(user);

  localStorage.setItem('selectedUser', userJson);

  window.open(`/ProviderDetails`, '_blank');
};

    const onEditPolygon = (index) => {
    };

    const handleGenerateKml = () => {
      if (shapeData || kmlUrl) {
        generateKml(shapeData, kmlUrl);
      } else {
        console.error('No shape data or KML URL available to generate KML.');
      }
    };
    const buttonLabel = kmlUrl || shapeData 
  ? "Search for drone pilots and companies in and around your area of interest"
  : "Please draw your area of interest";

  const onKMLUpload = async (file) => {
    setLoading(true); // Start loading

    const reader = new FileReader();
    reader.onload = async (e) => {
        const kmlContent = e.target.result;

        // Parse the KML content to extract coordinates
        const polygonCoords = parseKML(kmlContent);

        // Calculate the polygon area
        let totalArea = 0;
        polygonCoords.forEach(coords => {
            totalArea += calculateKMLUploadPolygonArea(coords);
        });

        // Compare the calculated area with the maximum allowed (100 square miles)
        if (totalArea > 100) {
          setError('The uploaded area exceeds the maximum limit of 100 square miles.');
          setShowErrorModal(true); // Show the error modal
            return; 
        }

        // Proceed with uploading the KML if the area is less than 100 sqaure miles
        const formData = new FormData();
        formData.append('kml_file', file);
        formData.append('user_type', 'customer');

        try {
            const response = await fetch(`${baseUrl}/upload_kml_on_map`, {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                setKmlUrl(data.url);
                setIsDisabled(false); // Enable the button
            } else {
                console.error('Failed to upload KML file');
            }
        } catch (error) {
            console.error('Error uploading KML file:', error);
        } finally {
            setLoading(false); // End loading
        }
    };

    reader.readAsText(file); // Read the KML file as text
};

// Parse the KML file and extract polygon coordinates
const parseKML = (kmlContent) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(kmlContent, "application/xml");
    const coordinates = xmlDoc.getElementsByTagName("coordinates");

    const polygonCoords = [];
    for (let i = 0; i < coordinates.length; i++) {
        const coordStr = coordinates[i].textContent.trim();
        const coordPairs = coordStr.split(/\s+/);
        const latLngs = coordPairs.map((pair) => {
            const [lng, lat] = pair.split(',').map(Number); // Split each pair and convert to numbers
            return { lat, lng };
        });
        polygonCoords.push(latLngs);
    }
    return polygonCoords;
};


// Function to calculate polygon area
const calculateKMLUploadPolygonArea = (polygonCoords) => {
  
  const poly = polygon([polygonCoords.map(coord => [coord.lng, coord.lat])]);

  // Calculate the area and convert from square meters to square kilometers
  const areaInSqKm = area(poly) / 1e6;

  // Convert square kilometers to square miles
  const areaInSqMiles = areaInSqKm * 0.386102;
  return areaInSqMiles;
};
      const map = mapRef.current;
      useEffect(() => {
        if (isCaptureCursor && map) {
          const handleMouseMove = (e) => {
            if (e.latLng) {
              const latLng = e.latLng;
              setHoverCoordinates({ lat: latLng.lat(), lng: latLng.lng() });
            }
          };
          map.addListener("mousemove", handleMouseMove);
        }
      }, [isCaptureCursor]);
      
      const handleMouseMove = (e) => {
        if (isCaptureCursor && e.latLng) {
          const latLng = e.latLng.toJSON();
          setHoverCoordinates(latLng);
        }
      };
      
      const handleMapClick = () => {
        if (isCaptureCursor && !isClickCaptured) {
          setIsClickCaptured(true); // Set click captured flag
          setHoverCoordinates(null); // Reset hover coordinates on click
          handleCloseInfoWindow(); // Close the info window on click
        }
      };
      const handleCloseInfoWindow = () => {
        setIsCaptureCursor(false);
        setHoverCoordinates(null);
        if (infoWindowRef.current) {
          infoWindowRef.current.close();
        }
      };
      const handleCursorCapture = () => {
        setIsCaptureCursor((prev) => !prev);
        setIsClickCaptured(false);
        // Toggle popup visibility on icon click
        setIsPopupActive(!isPopupActive);
        if (isCaptureCursor) {
          setHoverCoordinates(null);
        }
      };

      const handleKmlLayerLoad = () => {
        if (kmlUrl) {
          // Remove the previous KML layer if it exists
          if (kmlLayerRef.current) {
            kmlLayerRef.current.setMap(null);
            kmlLayerRef.current = null; // Clear the previous reference to force reload
          }
      
          // Create and load the new KML layer
          const kmlLayer = new window.google.maps.KmlLayer({
            url: kmlUrl,
            map: mapRef.current,
            preserveViewport: true, // Keep this to prevent zoom changes
          });
      
          // Store the reference of the new KML layer
          kmlLayerRef.current = kmlLayer;
      
          // Once the KML is loaded, set the zoom level
          window.google.maps.event.addListener(kmlLayer, 'defaultviewport_changed', () => {
            const bounds = kmlLayer.getDefaultViewport();
            if (bounds) {
              mapRef.current.fitBounds(bounds);
            }
          });
        }
      };
      
      useEffect(() => {
        handleKmlLayerLoad();
      }, [kmlUrl]);      

      const zoomToDrawnShapes = () => {
        if (mapRef.current && kmlUrl) {
          // Create a KML layer using the KML URL
          const kmlLayer = new window.google.maps.KmlLayer({
            url: kmlUrl,
            map: mapRef.current,
            preserveViewport: false, // Allow the viewport to change based on the KML content
          });
      
          // Listen for the KML layer to load
          window.google.maps.event.addListenerOnce(kmlLayer, 'defaultviewport_changed', () => {
            const bounds = kmlLayer.getDefaultViewport(); // Get the KML layer's default viewport
            if (bounds) {
              mapRef.current.fitBounds(bounds); // Fit the map to the KML layer's boundaries
              window.google.maps.event.addListenerOnce(mapRef.current, 'idle', () => {
                const boundsCenter = bounds.getCenter();
                const currentZoom = mapRef.current.getZoom();
                const adjustedZoom = currentZoom - 1; 
                mapRef.current.setCenter(boundsCenter);
                mapRef.current.setZoom(adjustedZoom);
              });
            } else {
              console.log("Unable to determine KML bounds.");
            }
          });
      
        } else {
          console.log("No KML file URL found to zoom to.");
        }
      };

      const CountrySelectKmlUrl = (url) => {
        setPolygons([])
        setKmlUrl(url);
        setIsDisabled(false); // Enable the button after selecting the country and setting the URL
      };

      useEffect(() => {
        // Enable button if either KML URL or shapeData is available
        if (kmlUrl || shapeData) {
          setIsDisabled(false);  // Enable button
        } else {
          setIsDisabled(true);  // Disable button
        }
      }, [kmlUrl, shapeData]);  // Run effect when kmlUrl or shapeData changes      


    return (
        isLoaded ? (
           <div style={{ display: "flex" }}>
            <div style={sidebarStyle}>
            <MapSidebar
             onKMLUpload={onKMLUpload} 
             setKmlUrl={CountrySelectKmlUrl}
             setCurrentLocationMarkerPosition={setCurrentLocationMarkerPosition} 
             setMarkerPosition={setMarkerPosition}  
             setCaptureCoordinates={handleCursorCapture} 
             setCenter={setCenter}
             setZoomLevel={setZoomLevel} 
             zoomToDrawnShapes={zoomToDrawnShapes}
              />
            </div>
                <div className="map-container" style={mapContainerStyle}>
                    {loading && (
                    <div style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)', // Ensures center alignment
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      padding: '10px',
                      borderRadius: '5px',
                      zIndex: 1000,
                      textAlign: 'center' // Center the text and spinner together
                    }}>
                      <div className="loading-container">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <p style={{ marginTop: '10px' }}>{loadingMessage || "Loading..."}</p> {/* Display custom message */}
                      </div>
                    </div>
                  )}
                <GoogleMap
                    zoom={zoomLevel}
                    center={center}
                    onLoad={onLoadMap}
                    mapContainerStyle={containerStyle}
                    onTilesLoaded={() => setCenter(null)}
                    onMouseMove={handleMouseMove}
                    onClick={handleMapClick}
                >
                    <DrawingManager
                        onLoad={onLoadDrawingManager}
                        onOverlayComplete={onOverlayComplete}
                        options={drawingManagerOptions}
                    />
                    {polygons.map((shape, index) => {
          if (shape.type === "rectangle") {
            return (
              <Rectangle
                key={index}
                onLoad={(event) => onLoadPolygon(event, index)}
                onMouseDown={() => onClickPolygon(index)}
                onMouseUp={() => onEditPolygon(index)}
                onDragEnd={() => onEditPolygon(index)}
                options={rectangleOptions}
                bounds={
                  new window.google.maps.LatLngBounds(
                    shape.bounds[0],
                    shape.bounds[2]
                  )
                }
                draggable
                editable
              />
            );
          } else {
            return (
              <Polygon
                key={index}
                onLoad={(event) => onLoadPolygon(event, index)}
                onMouseDown={() => onClickPolygon(index)}
                onMouseUp={() => onEditPolygon(index)}
                onDragEnd={() => onEditPolygon(index)}
                options={polygonOptions}
                paths={shape.paths}
                draggable
                editable
              />
            );
          }
        })}
                    <Autocomplete
                        onLoad={onLoadAutocomplete}
                        onPlaceChanged={onPlaceChanged}
                    >
                        <input
                            type='text'
                            placeholder='Search Location'
                            style={autocompleteStyle}
                        />
                    </Autocomplete>
                    {markerPosition && (
                    <Marker
                        position={markerPosition}
                        icon={CoordinatesMarker} // Optional: Use a custom icon for the marker
                    />
                        )}
                    {CurrentLocationMarkerPosition && (
                    <Marker
                    position={CurrentLocationMarkerPosition}
                    icon={currentLocationmarker} // Optional: Use a custom icon for the marker
                    />
                    )}

              {markers.length > 0 && markers.map((marker, index) => (
                <Marker
                    key={index}
                    position={marker.position}
                    icon={cityMarkerUser} // Custom icon if needed
                   >
                        <InfoWindow
                            position={marker.position}
                            options={{
                                pixelOffset: new window.google.maps.Size(0, -50) // Adjust the position above the marker
                            }}
                        >
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                            {marker.company_logo ? (
                                <img
                                    src={`data:image/png;base64,${marker.company_logo}`}
                                    alt={`${marker.company} logo`}
                                    style={{ width: "40px", height: "40px", objectFit: "contain", marginBottom: "15px" }}
                                />
                            ) : (
                                <img
                                    src={Default_logo}
                                    alt="Default logo"
                                    style={{ width: "40px", height: "40px", objectFit: "contain", marginBottom: "15px" }}
                                />
                            )}
                            {/* <p> {marker.company}</p> */}
                            <p>GeoWGS84 Partner No :{marker.GeoWGS84_partner_no} </p>
                            <p> {marker.city} </p>
                            <p>{marker.country}</p>
                            <button onClick={() => handleDetailClick(marker)} >
                            Details
                        </button>
                        </div>
                    </InfoWindow>
                </Marker>
            ))}                                        
                    {isPopupActive && hoverCoordinates && (
                        <InfoWindow
                        position={hoverCoordinates}
                        onCloseClick={handleCloseInfoWindow}
                        >
                        <div>
                            <p>
                            Latitude: {hoverCoordinates.lat.toFixed(6)}
                            </p>
                            <p>
                            Longitude: {hoverCoordinates.lng.toFixed(6)}
                            </p>
                            {/* Add optional reverse geocoding functionality here */}
                        </div>
                        </InfoWindow>
                    )}                   
                     {kmlUrl && (
                      <KmlLayer
                       url={kmlUrl}
                       options={{ preserveViewport: false }}
                       />
                     )}
                    {/* <KmlLayer url={kmlUrl} /> */}
                </GoogleMap>
                <Modal show={showErrorModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                  <Modal.Title>Alert</Modal.Title>
                </Modal.Header>
                <Modal.Body>{error}</Modal.Body>
                <Modal.Footer>
                  <Button 
                    variant="secondary" 
                    onClick={handleCloseModal} 
                    style={{ backgroundColor: '#EC9712', borderColor: '#EC9712' }}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>         
              <Button 
            onClick={handleGenerateKml} 
            disabled={!kmlUrl && !shapeData} 
            style={buttonStyle}
          >
            {buttonLabel}
          </Button>                
            </div>
            {showPopup && (
            <div style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '30px',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)',
                zIndex: 1000,
                width: '400px', // Increased width
                maxWidth: '90%', // Ensure it doesn't overflow on smaller screens
                textAlign: 'center' // Center the text inside the popup
            }}>
                <p style={{ fontSize: '16px', marginBottom: '20px' }}>{popupMessage}</p> {/* Larger font size */}
                
                {/* No Button */}
                <Button onClick={() => setShowPopup(false)} style={{ marginRight: '10px' }}>No</Button>
                
                {/* Yes Button */}
                <Button onClick={() => window.open('/ContactSalesForm', '_blank')}>Yes</Button>
            </div>
        )}

                
            </div>
            
        ) : null    
        
    );
}

export { Map };